<template>
  <div id="creators" class="creators-container">
    <img src="../assets/9Creatorsheader.png" />
    <div class="creators-section">
      <div class="creator-container">
        <img class="image" src="../assets/9Creators1.png" />
        <div class="creator-desc">
          <h2>Catnip</h2>
          <h3>A street artist and galactic ambassador,</h3>
          <h3>currently stationed on Gaia,</h3>
          <h3>painting walls and creating stories.</h3>
          <h3>Artist, Generator, Founder, Finder..</h3>
          <h3>Hoping to bring more peace to Earth.</h3>
          <br />
          <a href="https://twitter.com/lookupcatnip">
            <h3>Twitter:</h3>
            <h3>lookupcatnip</h3>
          </a>
        </div>
      </div>
      <div class="creator-container">
        <img class="image" src="../assets/9Creators2.png" />
        <div class="creator-desc">
          <h2>Beat Theatre</h2>
          <h3>A man like no other.</h3>
          <h3>Knows other. Fearless.</h3>
          <h3>Musician, Marketing,</h3>
          <h3>WorldBuilder, Creative Director.</h3>
          <br />
          <a href="https://twitter.com/BeatTheatre777">
            <h3>Twitter:</h3>
            <h3>BeatTheatre777</h3>
          </a>
        </div>
      </div>
      <div class="creator-container">
        <img class="image" src="../assets/9Creators3.png" />
        <div class="creator-desc">
          <h2>Don Flamingo</h2>
          <h3>Web3 Developer, Smart Contract writer,</h3>
          <h3>Architect of the future.</h3>
          <h3>The bigest Flamingo from the Family.</h3>
          <br />
          <a href="https://twitter.com/donflamingonft">
            <h3>Twitter:</h3>
            <h3>donflamingo</h3>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Creators",
};
</script>
<style lang="scss">
a {
  text-decoration: none;
}
.creators-section {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.creators-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.creator-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.creator-desc h2 {
  font-family: Phenomenopolisb;
  margin: 0;
  color: white;
  font-size: 64px;
  text-align: center;
}

.creator-desc h3 {
  font-family: Phenomenopolisb;
  margin: 0;
  color: white;
  font-size: 32px;
  text-align: center;
}

@media only screen and (max-width: 768px) {
  .creators-section {
    flex-direction: column;
  }
}
</style>
